import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IListarSuprimentoDetalhes } from 'src/app/interfaces/suprimentos/IListarSuprimentoDetalhes';
import {
  IAcessorio,
  IEquipamentoSuprimento,
  IGetAcessoriosQueryParams,
  IGetEquipamentosSuprimentoQueryParams,
  IGetSuprimentosChamadoQueryParams,
  IPostSuprimentoBody,
  IPostSuprimentoResponseData,
  ISuprimentosChamado
} from 'src/app/interfaces';
import { IApiResponse, IListaPaginada } from 'src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class SuprimentosService {
  private readonly baseURL = '/Suprimento';
  constructor(private httpClient: HttpClient) {}
  postSuprimento(body: IPostSuprimentoBody) {
    return this.httpClient.post<IApiResponse<IPostSuprimentoResponseData>>(
      this.baseURL,
      body
    );
  }
  getSuprimentosChamadoDetalhes(codSuprimento?: string) {
    return this.httpClient.post<IApiResponse<IListarSuprimentoDetalhes>>(
      `${this.baseURL}/Detalhe/${codSuprimento}`,
      {}
    );
  }
  getSuprimentosChamado(body: IGetSuprimentosChamadoQueryParams) {
    return this.httpClient.post<
      IApiResponse<IListaPaginada<ISuprimentosChamado>>
    >(`${this.baseURL}/ObterSuprimentos`, body);
  }

  getAcessorios(body: IGetAcessoriosQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IAcessorio>>>(
      `${this.baseURL}/Acessorio`,
      body
    );
  }

  getEquipamentosSuprimento(body: IGetEquipamentosSuprimentoQueryParams) {
    return this.httpClient.post<
      IApiResponse<IListaPaginada<IEquipamentoSuprimento>>
    >(`${this.baseURL}/Equipamento`, body);
  }
}
